import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ethereum': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M311.9 260.8L160 353.6 8 260.8 160 0 311.9 260.8zM160 383.4L8 290.6 160 512 312 290.6 160 383.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ethereum.js
// module id = rKDj
// module chunks = 144